module.exports = __webpack_public_path__ + "img/eduzhangqi.3260b3aa.png";